import React from 'react';
import routes from "../../../assets/apiRoutes.json";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { connect } from "react-redux";
import axios from "axios";
import {
  Column,
  DataGrid,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Toolbar,
  Item,
  Export,
  Editing,
  Paging,
  FilterBuilderPopup,
  ColumnChooser,
  ColumnFixing,
  Lookup,
  MasterDetail
} from "devextreme-react/data-grid";




const DetailTemplate = (props) => {
  var accessToken = props.oidc.user.access_token;
  var masterRow = props.data.data.masterrowid;
  console.log(props)

  //
  const onContentReady = (e) => {
    console.log(masterRow);
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", createStore({
        key: "masterrowid",
        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.pu_processing.FetchLotsToSelect}?key=${masterRow}`,
        updateUrl: `${window._env_.REACT_APP_APIS}/${routes.pu_processing.UpdateLotSelect}`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        },
      })
      );
    }
  };

  var seedSourceData = ["Weyer Inv", "Cust Inv", "Cust Seed"];  //
  const setWarehouseValue = (newData, value) => {
    newData.seeditem = null;
    newData.seedlot = null;
    newData.location = null;
    newData.rseedinventory = null;
    newData.germ = null;
    newData.purity = null;
    newData.seedslb = null;
    newData.warehouse = value;
  };

  const setSeedItemValue = (newData, value) => {
    newData.seedlot = null;
    newData.location = null;
    newData.rseedinventory = null;
    newData.germ = null;
    newData.purity = null;
    newData.seedslb = null;
    newData.seeditem = value;
  };

  const setSeedLotValue = (newData, value) => {
    newData.location = null;
    newData.rseedinventory = null;
    newData.germ = null;
    newData.purity = null;
    newData.seedslb = null;
    newData.pounds = null;
    newData.bags = null;
    newData.seedlot = value;
  };


  const getSeedInventory = (location, currentData) => {
    return axios.get
      (
        `${window._env_.REACT_APP_APIS}/${routes.master_records.GetSeedInventoryInfo}?itemCode=${currentData.speciescode}&warehouse=${currentData.warehouse}&seedItem=${currentData.seeditem}&seedLot=${currentData.seedlot}&location=${location}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken
          },
        }
      )
      .then(res => {
        return res.data;
      })
      .catch(error => { throw "Data Loading Error" });
  };

  const setLocationValue = (newData, value, currentData) => {
    return getSeedInventory(value, currentData).then(data => {
      newData.location = value;
      newData.rseedinventory = data.rowid;
      newData.germ = data.germ;
      newData.purity = data.purity;
      newData.seedslb = data.seedslb;
    });
  };

  const warehouseDataSource = () => {
    return createStore({
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.GetWarehouses}`,
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });
  };

  const seedLotDataSource = (options) => {
    return {
      store: createStore({
        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.GetSeedLots}`,
        loadParams:
        {
          masterRowId: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.masterrowid != null && options.data.masterrowid != undefined) {
                  return options.data.masterrowid;
                }
              }
            }
            return "00000000-0000-0000-0000-000000000000";
          },
          itemCode: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.speciescode != null && options.data.speciescode != undefined) {
                  return options.data.speciescode;
                }
              }
            }
            return "";

          },
          warehouse: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.warehouse != null && options.data.warehouse != undefined) {
                  return options.data.warehouse;
                }

                return "";
              }
            }

            return undefined;
          },
          seedItem: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.seeditem != null && options.data.seeditem != undefined) {
              return options.data.seeditem;
            }

            return "";
          },
          seedLot: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.seedlot != null && options.data.seedlot != undefined) {
              return options.data.seedlot;
            }

            return "";
          }
        },

        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
    };
  };

  const seedItemDataSource = (options) => {

    return {
      store: createStore({
        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.GetSeedItems}`,
        loadParams:
        {
          masterRowId: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.masterrowid != null && options.data.masterrowid != undefined) {
                  return options.data.masterrowid;
                }
              }
            }
            return "00000000-0000-0000-0000-000000000000";
          },
          itemCode: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.speciescode != null && options.data.speciescode != undefined) {
                  return options.data.speciescode;
                }
              }
            }
            return "";

          },
          warehouse: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.warehouse != null && options.data.warehouse != undefined) {
                  return options.data.warehouse;
                }

                return "";
              }
            }
            return undefined;
          },
          seedItem: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.seeditem != null && options.data.seeditem != undefined) {
              return options.data.seeditem;
            }

            return "";
          }
        },

        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
    };
  };

  const locationDataSource = (options) => {

    return {
      store: createStore({
        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.GetLocations}`,
        loadParams:
        {
          masterRowId: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.masterrowid != null && options.data.masterrowid != undefined) {
                  return options.data.masterrowid;
                }
              }
            }
            return "00000000-0000-0000-0000-000000000000";
          },
          itemCode: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.speciescode != null && options.data.speciescode != undefined) {
                  return options.data.speciescode;
                }
              }
            }
            return "";

          },
          warehouse: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.warehouse != null && options.data.warehouse != undefined) {
                  return options.data.warehouse;
                }

                return "";
              }
            }

            return undefined;
          },
          seedItem: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.seeditem != null && options.data.seeditem != undefined) {
              return options.data.seeditem;
            }

            return "";
          },
          seedLot: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.seedlot != null && options.data.seedlot != undefined) {
              return options.data.seedlot;
            }

            return "";
          },
          location: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.location != null && options.data.location != undefined) {
              return options.data.location;
            }

            return "";
          }
        },

        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
    };
  };


  return (

    <React.Fragment>
      <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
        id="detailContainer"
        keyExpr="masterrowid"
        onContentReady={(e) => onContentReady(e)}
        showBorders={true}
        columnAutoWidth={true}
      >
        <Editing
          mode="cell"
          refreshMode="reshape"
          allowUpdating={true}
          allowAdding={false}
          allowDeleting={false}
        />
        <Column dataField="seedsource" caption="Seed Source">
          <Lookup dataSource={seedSourceData} allowClearing={true} />
        </Column>
        <Column dataField="warehouse" caption="Warehouse" setCellValue={setWarehouseValue} >
          <Lookup dataSource={warehouseDataSource} displayExpr="name" valueExpr="name" allowClearing={true} />
        </Column>
        <Column dataField="seeditem" caption="Seed Item" setCellValue={(newData, value) => setSeedItemValue(newData, value)}>
          <Lookup dataSource={seedItemDataSource} displayExpr="name" valueExpr="name" allowClearing={true} />
        </Column>
        <Column dataField="seedlot" caption="Seed Lot" setCellValue={(newData, value) => setSeedLotValue(newData, value)}>
          <Lookup dataSource={seedLotDataSource} displayExpr="name" valueExpr="name" allowClearing={true} />
        </Column>
        <Column dataField="location" caption="Location" setCellValue={(newData, value, currentData) => setLocationValue(newData, value, currentData)}>
          <Lookup dataSource={locationDataSource} displayExpr="location" valueExpr="location" allowClearing={true} />
        </Column>
        <Column dataField="germ" dataType="number" caption="Germ" />
        <Column dataField="purity" dataType="number" caption="Purity" />
        <Column dataField="seedslb" dataType="number" caption="Seeds/Lb" />
        <Column dataField="pounds" dataType="number" caption="Lbs" />
        <Column dataField="bags" dataType="number" caption="Bags" />
      </DataGrid>
    </React.Fragment>
  );
};


function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}



// export default DetailTemplate;
// const ReduxGridDetailContainer = connect(state => state)(GridDetailContainer);
export default connect(mapStateToProps)(DetailTemplate);
